// Report pages: "Reset all" support.
// After a reset the top filter of the page receives the default values as props and reports them back via
// onAction (it reports every change of its values). That echo must not send a second request:
// the page remembers the reset values and skips one onAction call with exactly these values.

const FILTER_KEYS = ['startDate', 'endDate', 'timezone', 'bindActions', 'groupBy', 'count', 'onlyForTrafficInPeriod'];

const normalize = (key, value) => {
    if (key === 'startDate' || key === 'endDate') {
        return value && value.valueOf ? value.valueOf() : value;
    }
    if (key === 'count') {
        return (value === undefined || value === null || value === '') ? value : Number(value);
    }
    if (key === 'onlyForTrafficInPeriod') {
        return value ? 1 : 0;
    }
    return value;
};

// true when filterState has the same top filter values as resetValues (only the keys present in resetValues)
export const isSameFilterValues = (resetValues, filterState) => {
    if (!resetValues || !filterState) {
        return false;
    }

    return Object.keys(resetValues)
        .filter((key) => FILTER_KEYS.indexOf(key) !== -1)
        .every((key) => normalize(key, resetValues[key]) === normalize(key, filterState[key]));
};

export default {
    isSameFilterValues
};
